module.exports = __webpack_public_path__ + "static/media/file_text.0812ebdf.svg";